import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserX, AlertTriangle } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ImpersonationBanner = () => {
  const navigate = useNavigate();
  const [impersonationData, setImpersonationData] = useState(null);

  useEffect(() => {
    const data = sessionStorage.getItem("impersonation");
    if (data) {
      setImpersonationData(JSON.parse(data));
    }
  }, []);

  const exitImpersonation = async () => {
    try {
      // Call logout to clear impersonation cookies
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      await axios.post(`${API}/public/auth/logout`, {}, { withCredentials: true });
    } catch (err) {
      // Logout errors are non-critical - continue with session cleanup
      console.error("Impersonation logout failed:", err.message);
    }
    
    // Clear impersonation state and user data
    sessionStorage.removeItem("impersonation");
    localStorage.removeItem("user");
    
    // Redirect to admin login (they will need to re-authenticate)
    navigate("/admin/login");
    window.location.reload();
  };

  if (!impersonationData) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-black py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <AlertTriangle size={20} />
          <span className="font-medium">
            Impersonating: <strong>{impersonationData.impersonatedUser?.name}</strong> ({impersonationData.impersonatedUser?.email})
          </span>
        </div>
        <button
          onClick={exitImpersonation}
          className="flex items-center gap-2 px-4 py-1.5 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors font-medium text-sm"
        >
          <UserX size={16} />
          Exit Impersonation
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
